import React, { useState } from "react";
import { getNamesFromAreasIds, getNamesFromCitiesIds, getSearchableAreas, getSearchableCities } from "../utils/lists";

const PopupContent = ({ setAreasIdsFilter, setCitiesIdsFilter, areasIdsFilter, citiesIdsFilter, cities, setSelectPopupOpen }) => {
  const [searchText, setSearchText] = useState("");

  return (
    <>
      <div className="m-auto w-full h-full" onClick={() => setSearchText("")}>
        <div className=" m-auto w-fit max-w-[380px]">
          <h2 className="w-fit text-white font-bold text-xl mb-5 mx-auto">סינון לפי יישובים/אזורים</h2>
          <div class="flex m-auto gap-1  ">
            <input
              value={searchText}
              onChange={({ target }) => setSearchText(target.value)}
              className="py-[1px] p-2 rounded-xl min-w-[230px] max-w-[300px] w-[70%] bg-[#111111] text-white text-md"
              placeholder="הזן את שם היישוב/אזור..."
              type="text"
            />
            <button
              onClick={() => {
                setAreasIdsFilter([]);
                setCitiesIdsFilter([]);
              }}
              className="bg-[#111111] rounded-xl w-[20%] min-w-[100px]  text-white text-md"
            >
              נקה בחירה
            </button>

            <div className="absolute mt-7  rounded-xl min-w-[230px] max-w-[300px] w-[70%] z-5 flex flex-col overflow-auto bg-[#111111] w-[30%] max-h-[150px] mr-auto">
              {getSearchableAreas(searchText, cities).map((c) => (
                <button className="text-[#F4D03F]" onClick={() => setAreasIdsFilter((curr) => [...curr, c.id])}>
                  אזור {c.name}
                </button>
              ))}
              {getSearchableCities(searchText, cities).map((c) => (
                <button className="text-white" onClick={() => setCitiesIdsFilter((curr) => [...curr, c.id])}>
                  {c.name}
                </button>
              ))}
            </div>
          </div>

          <div className="flex gap-1 mt-5 mb-5 flex-wrap">
            {getNamesFromAreasIds(areasIdsFilter, cities).map((area) => (
              <div className="bg-[#111111] rounded-xl text-[#F4D03F] px-[9px] py-[2px] text-sm">
                אזור {area.name}{" "}
                <span onClick={() => setAreasIdsFilter((curr) => curr.filter((aid) => aid !== area.id))} className="mr-1 cursor-pointer">
                  x
                </span>
              </div>
            ))}
            {getNamesFromCitiesIds(citiesIdsFilter, cities).map((city) => (
              <div className="bg-[#111111] rounded-xl text-[#c4c4c4] px-[9px] py-[2px] text-sm">
                {city.name}{" "}
                <span onClick={() => setCitiesIdsFilter((curr) => curr.filter((cid) => cid !== city.id))} className="mr-1 cursor-pointer">
                  x
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex w-full justify-between">
        <button className="w-[100%] bg-red-600 text-white  rounded-xl" onClick={() => setSelectPopupOpen(false)}>
          סיום
        </button>
      </div>
    </>
  );
};

export default PopupContent;
